import { render, staticRenderFns } from "./BankDeposit.vue?vue&type=template&id=633c0224&scoped=true&"
import script from "./BankDeposit.vue?vue&type=script&lang=js&"
export * from "./BankDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c0224",
  null
  
)

export default component.exports